import { render } from "./SearchSvg.vue?vue&type=template&id=4f54807e&bindings={}"
import script from "./SearchSvg.vue?vue&type=script&lang=ts"
export * from "./SearchSvg.vue?vue&type=script&lang=ts"
script.render = render

export default script